import React, { useState, useEffect, useRef } from 'react';
import useFetch from '../../Services/useFetch';
import { useAuth } from '../../Services/AuthContext';
import { endpoints, RoleNames } from '../../utils/Constants';
import SupplierDetail from '../Cards/SupplierDetail'
import {  useFormikContext,getIn } from 'formik';
import ErrorMessage from './ErrorMessage'
import { useEdit } from '../../Services/EditContext';
import LoadingAnimation from './LoadingAnimation';
import Selector from './Selector';
import { Button } from 'react-bootstrap';

const AdminSupplierSelector = ({ route, value, id,isMulti, charterRequestId }) => {
    const getSelector = (suppliers) => {
        return suppliers ? suppliers.map(supplier => { return { label: supplier.companyName + ' | ' + supplier.firstName + ' | ' + supplier.lastName + ' | ' + supplier.email, value: supplier.id } }) : [];
    }


    const { setFieldValue,errors,touched } = useFormikContext();
    const [edit] = useEdit();
    const [suppliers, loading, error] = useFetch(edit?endpoints.getAllSuppliers:null);
    const [suppliersSelect, setsuppliersSelect] = useState(suppliers ? getSelector(suppliers) : []);
    const [supplier, setSupplier] = useState();
    const [selectValue, setSelectValue] = useState();
    const [selectedSupplierId, setSelectedSupplierId] = useState(null);
    const [markingUnavailable, setMarkingUnavailable] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');
    const [statusType, setStatusType] = useState('success');
    const statusTimerRef = useRef(null);
    const [auth] = useAuth();

    useEffect(() => {
        const select = getSelector(suppliers);
        setsuppliersSelect(select)
    }, [suppliers]);
    useEffect(() => {
        if (suppliersSelect) {
            if (isMulti) {
                const v = suppliersSelect.filter(xx => { return value.find(x => x === xx.value) });
                setSelectValue(v);
            }
            else {
                const c = suppliers?.find(xx => { return xx.value === value });
                setSupplier(c);
                const v = suppliersSelect.find(xx => { return xx.value === value });
                setSelectValue(v);
                setFieldValue('supplier', c);
            }
        }
    }, [isMulti,suppliers,suppliersSelect, value, setFieldValue]);

    useEffect(() => {
        if (!statusMessage) return;

        if (statusTimerRef.current) {
            clearTimeout(statusTimerRef.current);
        }

        statusTimerRef.current = setTimeout(() => {
            setStatusMessage('');
        }, 5000);

        return () => {
            if (statusTimerRef.current) {
                clearTimeout(statusTimerRef.current);
            }
        };
    }, [statusMessage]);


    const onSelectChange = (newValue) => {
        if (isMulti) {
            setFieldValue(id, newValue.map(x => x.value));
        }
        else
        {
            setFieldValue(id, newValue.value);
            setSelectedSupplierId(newValue.value);
            setStatusMessage('');
        }
    }

    const handleMarkUnavailable = async (isUnavailable) => {
        if (!selectedSupplierId) return;

        const headers = {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${auth.jwt}`
            }

        setMarkingUnavailable(true);
        try {
            const response = await fetch(endpoints.markSupplierUnavailable, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    supplierId: selectedSupplierId,
                    status: isUnavailable ? 'Unavailable' : 'Available',
                    charterRequestId: charterRequestId,
                }),
            });

            if (response.ok) {
                setStatusType('success');
                setStatusMessage(`Supplier marked as ${isUnavailable ? 'unavailable' : 'available'}`);
            } else {
                console.log('Failed to update supplier availability:', response);
                setStatusType('error');
                setStatusMessage('Failed to update supplier availability');
            }
        } catch (err) {
            console.log('Error updating supplier availability:', err);
            setStatusType('error');
            setStatusMessage('Error updating supplier availability: ' + err.message);
        } finally {
            setMarkingUnavailable(false);
        }
    }

    return <React.Fragment>
        {edit && suppliersSelect ? <h1>Select Supplier</h1> : null}
        {edit && suppliersSelect ? <Selector hideAllButton isMulti={isMulti} invalid={getIn(errors, id) && getIn(touched, id)} options={suppliersSelect} onChange={onSelectChange} value={selectValue} /> : ''}
        {!isMulti && selectedSupplierId && edit ?
            <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ minHeight: '20px', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                    {statusMessage ?
                        <span style={{ color: statusType === 'error' ? '#b22222' : '#2e7d32', fontSize: '0.9rem', fontWeight: 'bold' }}>
                            {statusMessage}
                        </span>
                    : ''}
                </div>
                <div style={{ marginLeft: '10px' }}>
                    <Button
                        variant="warning"
                        size="sm"
                        onClick={() => handleMarkUnavailable(true)}
                        disabled={markingUnavailable}
                        style={{ marginRight: '5px' }}
                    >
                        Mark Unavailable
                    </Button>
                    <Button
                        variant="success"
                        size="sm"
                        onClick={() => handleMarkUnavailable(false)}
                        disabled={markingUnavailable}
                    >
                        Mark Available
                    </Button>
                </div>
            </div>
        : ''}
        {!edit && supplier ? <SupplierDetail route={route} supplier={supplier} charterRequestId={charterRequestId} /> : null}
        {loading ? <LoadingAnimation height={'50px'} />  : ''}
        {error ? <p> error</p> : ''}
    </React.Fragment>

}
const SupplierSelector = ({ route, name, id,isMulti, isClientView, charterRequestId }) => {

    const [user] = useAuth();
    const [edit] = useEdit()
    const {  setFieldValue,values, ...rest } = useFormikContext();
    useEffect(() => {
        if ( edit) {
            if (user.role === RoleNames.Supplier) {
                if (values[id] !== user.supplierId) {
                    setFieldValue(id, user.supplierId);
                }
            }
        }
    }, [ user, setFieldValue, name, values,edit,id]);

    if (user.role === RoleNames.Admin) {
        return <React.Fragment>
            {edit ? <AdminSupplierSelector  isMulti={isMulti}  route={route} id={id} {...rest} value={values[id]} charterRequestId={charterRequestId} /> : null}
            <ErrorMessage name={id} />
            <SupplierDetail route={route} supplier={values.supplier} isClientView={isClientView} charterRequestId={charterRequestId} />
        </React.Fragment >
    }
    else if (user.canViewSupplierInfo) {
        return <React.Fragment>
           
            {!edit && values.supplier ? <SupplierDetail route={route} supplier={values.supplier} isClientView={isClientView} charterRequestId={charterRequestId} /> : null}
            <ErrorMessage name={id} />
        </React.Fragment>
    }
    else{
        return <ErrorMessage name={id} />;
    }
}

export default SupplierSelector; 